<div class="p-3">
    <div class="d-flex justify-content-between my-4 mx-3">
        <div class="row">
        <h5>{{ schemeType === 'tdf' ? 'Critical Design' : 'Nomination of QA Agency' }}  - <span class="text-primary"> [{{payload?.proposal_name}}]</span></h5>
         <h6><span class="text-primary"> [
                    {{
                    stepDetails?.step_status == 0
                    ? 'INITIATION PENDING'
                    : (stepDetails?.step_status | uppercase)
                    }}
                    ]</span></h6>
                    </div>
        <div class="d-flex gap-2">
            <p-button pTooltip="Generate PDF" icon="pi pi-file-pdf" (onClick)="generatePDF()" [outlined]="true"></p-button>
            <!-- <p-button pTooltip="Edit Form" icon="pi pi-pencil" (onClick)="editForm()" [outlined]="true"></p-button> -->
                       <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
                [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
            <p-button label="Submit" icon="pi pi-save" (onClick)="onSubmit()" [outlined]="true" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)"></p-button>
            <p-button label="Initiate" icon="pi pi-play" *ngIf="stepDetails?.is_initiator"
                (onClick)="IRA.emit('Initiate')" [outlined]="true"></p-button>
            <p-button label="Approve" icon="pi pi-check-circle" *ngIf="stepDetails?.is_approver"
                (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
            <p-button label="Recommend" icon="pi pi-thumbs-up" *ngIf="stepDetails?.is_recommender"
                (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>


        </div>
    </div>
    <hr>



    <form [formGroup]="commentForm">
          <ng-container>

        <!-- <h5 class="mb-3">Uploaded Files</h5>
        <ul>
            <li *ngFor="let file of qaAgencyData?.nomination_data[0]?.nomination_file">
                <a href="{{base_url}}{{file.file}}" target="_blank">{{getFileExtension(file.file)}}</a>
            </li>
        </ul> -->
        <h5 class="mb-3">AIP Document</h5>
        <ul>
            <li *ngFor="let file of qaAgencyData?.aip_data">
                <a href="{{base_url}}{{file.document}}" target="_blank">{{getFileExtension(file.document)}}</a>
            </li>
        </ul>
    </ng-container>
        <div class="mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Criticality of item <b class="text-danger">*</b> </label>

            <!-- <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor> -->
              <editor [init]="init" formControlName="comment"  [disabled]="isEditorDisabled" ></editor>

        </div>
    </form>





    <!-- <button type="submit" (click)="onSubmit()" class="btn btn-primary">Submit</button> -->



</div>